define('Stock.Status.Model', [
    'Backbone',
    'SC.Configuration',
    'underscore'
], function StockStatusModel(
    Backbone,
    Configuration,
    _
) {
    'use strict';

    return Backbone.Model.extend({
        url: _.getAbsoluteUrl('services/Stock.Status.Service.ss'),
        parse: function parse(response) {
            var multipleStock = Configuration.get('customizations.stockStatus.multipleIds');
            if (multipleStock) {
                return response;
            }
            return response[0];
        }
    });
});

